import { Avatar, Menu, Popover, Button } from 'antd'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import menus from './menus'
import './header.less'
import { useDispatch, useSelector } from 'react-redux'
import { IState } from '../../reducers'
import { ObsKeyToURL } from '../../api/utils'
import { UpdateOrgTypes } from '../../reducers/org'
import { DownOutlined } from '@ant-design/icons'
import API from 'api'
import LoginCardCom from 'components/LoginCard'
import { REFRESH_TOKEN, TOKEN } from 'api/constants'
import { saveUser } from 'reducers/user'
import { newUser } from 'api/user'
import { SetCurrentGrade } from 'reducers/course'

const Header = () => {
  const history = useHistory()
  const [selectedKey, setSelectedKey] = useState('')
  const modules = useSelector((state: IState) => state.org.modules)
  const [loginCardVisible, setVisible] = useState(false)
  const user = useSelector((state: IState) => state.user)

  const dispatch = useDispatch()

  // 加载时，依据目录高亮对应的导航栏
  // 获取用户拥有的教学年级列表
  useEffect(() => {
    console.log('get user ', user)

    let path = history.location.pathname

    // 根据用户信息， 获取账户拥有的年级
    if (user.user_id !== '') {
      console.log('user ', user.role)

      if (user.role !== null) {
        let ms: number[] = []

        if (user.type === 'school') {
          user.role?.users?.forEach(r => {
            ms.push(r.module_id)
          })
        } else if (user.type === 'teacher') {
          user.role?.modules?.forEach(r => {
            ms.push(r.module_id)
          })
        }
        ms.sort()
        ms = Array.from(new Set(ms))
        dispatch(UpdateOrgTypes(ms))
      } else {
        dispatch(UpdateOrgTypes([]))
      }
    }
    let hasPath = false
    menus.forEach(menu => {
      if (path.includes(menu.path)) {
        setKey(menu.path)
        hasPath = true
        return
      }
    })
    if (!hasPath) {
      setKey('')
    }
    if (path.includes('/courses') || path.includes('/preview')) {
      setKey('/grades')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.pathname, user.user_id])

  const setKey = (key: string) => {
    setSelectedKey(key)
  }

  // 选择导航菜单按钮
  const selectKey = ({ key }) => {
    if (API.hasLogin()) {
      if (key === '/code') {
        // window.open('http://code.glitech.com')
        let w = window.open(process.env.REACT_APP_ORIGIN_URL)
        console.log('123-process.env.REACT_APP_ORIGIN_URL', process.env.REACT_APP_ORIGIN_URL);

        setTimeout(() => {
          w?.postMessage(
            {
              user: user,
              token: sessionStorage.getItem(TOKEN),
              refresh_token: sessionStorage.getItem(REFRESH_TOKEN),
            },
            process.env.REACT_APP_ORIGIN_URL ? process.env.REACT_APP_ORIGIN_URL : ''
          )
        }, 1000)
        return
      }
      if (user.type === "student") {
        logout()
        return
      }
      let path = key
      if (key === '/grades') {
        console.log(modules)
        dispatch(SetCurrentGrade(modules[0].grades[0]))
        path = path + '/' + modules[0].grades[0].id
      }
      history.push(path, { grade: modules[0].grades[0] })
      setKey(key)
    } else {
      setVisible(true)
    }
  }
  //退出
  const logout = () => {
    history.push('/login')
    sessionStorage.clear()
    dispatch(saveUser(newUser()))
  }
  const userPopups = (
    <div className="common-header-user-popup-items">
      <p
        onClick={e => {
          selectKey({ key: '/user/info' })
          e.stopPropagation()
        }}
      >
        账号信息
      </p>
      <p
        onClick={e => {
          selectKey({ key: '/user/suggestions' })
          e.stopPropagation()
        }}
      >
        使用建议
      </p>
      <p onClick={logout}>退出</p>
    </div>
  )

  return (
    <>
      <div className="common-header">
        <div
          className="common-header-logo"
          style={{
            backgroundImage: `url(${user.org.image !== '' && user.org.image !== undefined
              ? ObsKeyToURL(user.org.image)
              : process.env.PUBLIC_URL + '/images/login-form-logo.png'
              }`,
          }}
          onClick={() => selectKey({ key: '/home' })}
        ></div>
        <Menu
          onClick={selectKey}
          mode="horizontal"
          className="common-header-menu"
          selectedKeys={[selectedKey]}
        >
          {menus.map(menu => {
            // 修改NOC赛事权限
            // if (menu.verify) {
            //   if (user.type === 'guest' || user.type === '' || user.type === 'student') {
            //     return null
            //   }
            // }
            return (
              <Menu.Item className="common-header-item" key={menu.path}>
                {menu.title}
              </Menu.Item>
            )
          })}
        </Menu>
        {API.hasLogin() ? (
          <div className="common-header-user-group" onClick={() => selectKey({ key: '/user/info' })}>
            <Avatar
              className="common-header-user-avatar"
              src={user.image ? ObsKeyToURL(user.image) : ''}
            ></Avatar>
            <Popover
              className="common-header-user-popup"
              trigger="hover"
              content={userPopups}
              placement="bottomRight"
            >
              <div className="common-header-username">
                {user.nickname || user.username || user.name}
              </div>
              <DownOutlined />
            </Popover>
          </div>
        ) : (
          <Button
            type="primary"
            className="home-login-button"
            onClick={() => history.push('/login')}
          >
            登录
          </Button>
        )}
      </div>
      <LoginCardCom loginCardVisible={loginCardVisible} setVisible={setVisible} />
    </>
  )
}

export default Header
